import React, { Component } from 'react';
import Modal from '@tencent/dui/lib/components/Modal';
import Snackbar from '@tencent/dui/lib/components/Snackbar';
import Button from '@tencent/dui/lib/components/Button';
import classNames from 'classnames';
import HistoryItem from '../item';

import Style from './history-list.less';
import i18n from '@i18next/i18n';

interface IHistoryListProps {
    showTab: boolean;
    showAccusationSupportPage(jumpToSubmit?: boolean): void;
    getHistory(...args: any): any;
    getColor(...args: any): any;
    getHistorySlide(...args: any): any;
    getAuthor(...args: any): any;
    revert(...args: any): any;
}

interface IHistoryListStates {
    historyItems: Array<any>;
    selectingItem: { main: any, sub: any };
}

export default class HistoryList extends Component<IHistoryListProps, IHistoryListStates> {
    // 是否第一次请求，第一次要默认选中第一个记录
    private isFirstRequired = false;
    // 总记录页数
    private totalPages = 0;
    // 已经拉取的页数
    private fetchedPages = 0;
    // 最新版本，默认是第一页的
    private maxVersion = 0;
    // 是否正在拉取
    private isFetching = false;
    // 滑动偏移，用来计算增量拉取位置
    private prevScrollTop = 0;
    // 回滚的小版本号
    private revertRev = -1;
    // 回滚的大版本号
    private revertVersion = -1;
    private modal?: ReturnType<typeof Modal.confirm>;


    public constructor(props) {
        super(props);
        this.state = {
            historyItems: [],
            selectingItem: { main: undefined, sub: undefined },
        };
    }

    public componentDidMount() {
        this.fetchNextPage();
    }

    public fetchNextPage() {
        if (!this.hasMore() || this.isFetching) {
            return;
        }
        this.isFetching = true;
        this.props.getHistory?.(this.fetchedPages + 1, (response) => {
            this.isFetching = false;
            this.handleFetchedResult(response);
        }, () => {
            this.isFetching = false;
        });
    }

    public render() {
        const { main } = this.state.selectingItem;
        const { sub } = this.state.selectingItem;
        const { showTab } = this.props;
        return (
            <div className={classNames(Style['history-list'], {
                [Style['history-list-tab-show']]: showTab,
            })} onScroll={this.onScroll.bind(this)}>
                {this.state.historyItems.map((item, index) => (
                    <HistoryItem
                        item={item}
                        key={item.v}
                        maxVersion={this.maxVersion}
                        selected={main === index}
                        selectedSub={main === index ? sub : undefined}
                        getAuthor={this.getAuthor.bind(this)}
                        onItemClick={this.onItemClick.bind(this, index)}
                        onItemRevertClick={this.onItemRevertClick.bind(this, index)}
                        getColor={this.props.getColor} />
                ))}
            </div>
        );
    }

    private hasMore() {
        return this.totalPages === 0 || this.fetchedPages < this.totalPages;
    }

    private handleFetchedResult(result) {
        const { items } = result.history;
        const totalPages = result.history.pages;
        const fetchedPages = result.history.page;
        const newItems = this.state.historyItems.concat(items);
        this.totalPages = totalPages;
        this.fetchedPages = fetchedPages;
        this.setState({
            historyItems: newItems,
        });
        // first request
        if (!this.isFirstRequired) {
            this.maxVersion = newItems.length > 0 ? newItems[0].v : 0;
            this.isFirstRequired = true;
            this.onItemClick(0);
        }
    }

    private onItemClick(index, subIndex?) {
        // if (index === this.state.selectingItem.main && subIndex === this.state.selectingItem.sub) {
        //     return;
        // }
        if (this.isFetching) {
            return;
        }
        this.isFetching = true;
        let rev = 0;
        let fRev = 0;
        if (typeof (subIndex) === 'undefined') {
            const item = this.state.historyItems[index];
            rev = item.i;
            fRev = this.getFRev(index);
            this.setState({
                selectingItem: { main: index, sub: undefined },
            });
        } else {
            const item = this.state.historyItems[index];
            const subItem = item.l[subIndex];
            rev = subItem.i;
            fRev = this.getFRev(index, subIndex);
            this.setState({
                selectingItem: { main: index, sub: subIndex },
            });
        }
        this.props.getHistorySlide?.(rev, fRev, () => {
            this.isFetching = false;
        }, () => {
            this.isFetching = false;
            Snackbar.show({
                message: i18n.t('拉取失败'),
                duration: 2000,
            });
        });
    }

    private onItemRevertClick(index, subIndex) {
        const item = this.state.historyItems[index];
        if (!item) {
            return;
        }
        let rev = 0;
        let version = 0;
        if (typeof (subIndex) === 'undefined') {
            rev = item.i;
            version = item.v;
        } else {
            const subItem = item.l[subIndex];
            if (!subItem) {
                return;
            }
            rev = subItem.i;
            version = item.v;
        }
        this.revertRev = rev;
        this.revertVersion = version;
        this.showRevertModal();
    }

    private getAuthor(id) {
        if (this.props.getAuthor) {
            return this.props.getAuthor(id);
        }
        return '';
    }

    private onScroll(event) {
        const dom = event.target;
        const { scrollTop } = dom;
        const remainHeight = dom.scrollHeight - (scrollTop + dom.offsetHeight);
        if (remainHeight < 112 && scrollTop > this.prevScrollTop) {
            this.fetchNextPage();
        }
        this.prevScrollTop = scrollTop;
    }

    private getFRev(index, subIndex?) {
        let fRev = -1;
        const item = this.state.historyItems[index];
        if (item.r) { // 某个版本还原而来，不需要fRev
            fRev = -1;
        } else if (typeof (subIndex) === 'undefined') {
            const nextItem = this.state.historyItems[index + 1];
            if (nextItem) {
                fRev = nextItem.i;
            }
        } else {
            // eslint-disable-next-line no-shadow
            const item = this.state.historyItems[index];
            const nextSubItem = item.l[subIndex + 1];
            if (nextSubItem) {
                fRev = nextSubItem.i;
            } else {
                const nextItem = this.state.historyItems[index + 1];
                if (nextItem) {
                    fRev = nextItem.i;
                }
            }
        }
        return fRev;
    }

    private showRevertModal = () => {
        this.modal = Modal.confirm({
            title: i18n.t('提示'),
            content: <span>{i18n.t('确认将文档还原到该版本吗？')}</span>,
            okText: i18n.t('确定'),
            cancelText: i18n.t('取消'),
            onOk: this.confirmRevert,
            onCancel: this.hideRevertModal,
        });
    };

    private hideRevertModal = () => {
        this.revertRev = -1;
        this.revertVersion = -1;
        this.modal?.close();
    };

    private confirmRevert = () => {
        this.props.revert?.(this.revertRev, this.revertVersion, () => {
        }, () => {
            setTimeout(this.showRevertFailModal, 20);
        });
        this.hideRevertModal();
    };

    private showRevertFailModal = () => {
        this.modal = Modal.confirm({
            title: i18n.t('提示'),
            content: <span>{i18n.t('恢复失败，请稍后重试。')}</span>,
            footer: (
                <div style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    marginTop: 24,
                }}>
                    <Button type="primary" style={{ marginRight: 16 }} onClick={this.gotoFeedback}>{i18n.t('我要反馈')}</Button>
                    <Button type="primary" onClick={this.hideRevertFailModal}>{i18n.t('确定')}</Button>
                </div>
            ),
        });
    };

    private hideRevertFailModal = () => {
        this.modal?.close();
    };

    private gotoFeedback = () => {
        this.props.showAccusationSupportPage(true);
        this.modal?.close();
    };
}
